<template>
  <div class="member-center">
    <navbar show-home title="会员中心" />
    <div class="header">
      <div class="user-info" v-if="userInfo">
        <img alt src="../assets/img/member-center-icon.png" />
        <div class="phone">{{ userInfo.phone }}</div>
        <div class="level">
          {{ userInfo.info.name }}
          <em v-if="userInfo.level > 1">{{ userInfo.exp_at }}</em>
        </div>
      </div>
    </div>
    <div class="open-member upgrade-package" v-show="packageKinds.length">
      <div class="title">
        <span class="title-wrapper">
          <em>开通移动王卡PLUS套卡</em>
          享十大权益
        </span>
      </div>
      <div class="package-price-options">
        <a
          :class="{ 'package-option-checked': meal.offer_id == packageType }"
          :key="index"
          @click="switchPackage(index, meal.offer_id)"
          class="package-option"
          href="javascript:;"
          v-for="(meal, index) in packageKinds"
        >
          <div class="package-tit">
            <span class="tit">
              <img alt src="../assets/img/member-center/vipcown.png" />
              <span>{{ meal.name }}</span>
            </span>
            <span class="name">{{ meal.simple_title }}</span>
          </div>
          <div class="package-desc van-ellipsis">{{ meal.info }}</div>
          <div class="view-more-desc">
            <button @click.prevent="showPackageInfo">查看更多套餐资费说明>></button>
          </div>
        </a>
      </div>
      <!-- <div class="open-member-functional">
        <button @click="upgradePackage">
          <span>立即升级套餐</span>
        </button>
      </div>-->
    </div>
    <div class="open-member" v-show="priceList.length">
      <div class="title" v-show="!packageKinds.length">
        <span class="title-wrapper">
          <em>
            <span v-if="userInfo.level == 1">开通</span>
            <span v-else-if="userInfo.level > 1">续费</span>
            {{ memmberName }}
          </em>
          享十大权益
        </span>
      </div>
      <div class="price-options">
        <a
          :class="{ 'option-checked': price.type == selectedType }"
          :key="index"
          @click="switchMeal(index, price.type)"
          class="option"
          href="javascript:;"
          v-for="(price, index) in priceList"
        >
          <span>{{ price.title }}</span>
          <span>
            ¥
            <em>{{ price.price }}</em>
          </span>
        </a>
      </div>
      <div class="open-member-functional">
        <button @click="upgradePackage" v-if="packageStatus">立即升级套餐</button>
        <button @click="submit" v-else>
          <span v-if="userInfo.level == 1">立即开通</span>
          <span v-else-if="userInfo.level > 1">立即续费</span>
        </button>
      </div>
      <div class="records">
        <button @click="$router.push({name: 'memberOrderRecords'})">开通记录</button>
      </div>
    </div>
    <div class="member-privilege" style="display: none">
      <div class="title">
        <img alt src="../assets/img/member-center-tit.png" />
      </div>
      <div class="privilege-list">
        <a
          :key="index"
          class="privilege-item"
          href="javascript:;"
          v-for="({ configer }, index) in memberRights"
        >
          <div class="intro">
            <span class="name">{{ configer.title }}</span>
            <span class="desc">{{ configer.subtitle }}</span>
          </div>
          <div class="rights-icon">
            <img v-lazy="configer.img" />
          </div>
        </a>
      </div>
      <div class="comming-soon">
        <button>更多权益 敬请期待</button>
      </div>
    </div>

    <!-- 本地权益 -->
    <!-- <div class="local-rights">

    </div>-->

    <!-- 会员特卖 -->
    <div class="member-fling-module" v-show="flingBanners.length">
      <div class="fling-tit">
        <img alt src="../assets/img/member-center/fling-tit.png" />
      </div>
      <ul class="fling-banners">
        <li :key="index" class="banner" v-for="({configer}, index) in flingBanners">
          <a @click="jumpFling(configer)" class="jump-fling" href="javascript:;">
            <img alt v-lazy="configer.img" />
          </a>
        </li>
      </ul>
    </div>

    <!-- 会员遮罩层 -->
    <member-center-tips @close="closeTips" v-model="showTips"></member-center-tips>

    <!-- 订购会员二次确认 -->
    <dialogs
      :confrim-text="dialog.confrimText"
      :show-msg="false"
      @cancel-handler="cancelHandler"
      @confrim-handler="confrimHandler"
      class="dialogs"
      v-model="dialog.show"
    >
      <template>
        <div class="open-member-desc" v-show="selectedType === 1">
          尊敬的客户，您好！您将订购{{ mealDetails.price }}元{{
          mealDetails.title
          }}，资费{{ mealDetails.price }}元/{{
          mealDetails.exp
          }}天，订购后立即生效，会员权益从订购之日起{{
          mealDetails.exp
          }}天内有效。订购成功后畅享购物、娱乐、本地生活等更多优质权益。权益包下周期自动续订。
        </div>
        <div class="open-member-desc" v-show="selectedType === 4">
          尊敬的客户，您好！您将订购{{ mealDetails.price }}元{{
          mealDetails.title
          }}，资费{{ mealDetails.price }}元/{{
          mealDetails.exp
          }}天，订购后立即生效，会员权益从订购之日起{{
          mealDetails.exp
          }}天内有效。订购成功后畅享购物、娱乐、本地生活等更多优质权益。到期自动失效，到期后可再次订购。
        </div>
      </template>
    </dialogs>

    <!-- 套餐详情 -->
    <dialogs
      :show-cancel="false"
      :show-msg="false"
      @cancel-handler="closePackageInfo"
      @confrim-handler="closePackageInfo"
      class="dialogs"
      v-model="packageInfo.show"
    >
      <div class="package-desc">{{ chackedPackage.info }}</div>
    </dialogs>

    <!-- 升级套餐二次确认 -->
    <dialogs
      :confrim-text="upgradePackageInfo.confrimText"
      :show-msg="false"
      @cancel-handler="ungradeCancelHandler"
      @confrim-handler="ungradeConfrimHandler"
      class="dialogs"
      v-model="upgradePackageInfo.show"
    >
      <template>
        <div
          class="open-member-desc"
        >确定要升级为 {{chackedPackage.name}} {{chackedPackage.simple_title}} 么?</div>
      </template>
    </dialogs>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Navbar from '../components/NavBar'
import Dialogs from '../components/Dialog'
import MemberCenterTips from '../components/memberCenter/MemberCenterTips'
import api from '../utils/api.js'
let flag = false
export default {
  name: 'memberCenter',
  components: {
    Navbar,
    Dialogs,
    MemberCenterTips
  },
  data () {
    return {
      memberRights: [],
      flingBanners: [],
      memberIntro: [],
      packageKinds: [],
      packageType: 0,
      packageStatus: false,
      priceList: [],
      selectedType: '',
      current: 0,
      tipChecked: true,
      level: '',
      dialog: {
        show: false,
        confrimText: '确认订购'
      },
      packageInfo: {
        show: false,
        showCancel: false
      },
      upgradePackageInfo: {
        show: false,
        confrimText: '确认升级'
      },
      mealDetails: {
        title: '',
        price: '',
        exp: ''
      },
      memmberName: '',
      showTips: false
    }
  },
  computed: {
    ...mapState('store', ['userInfo', 'rebateInfo']),
    chackedPackage () {
      return (
        this.packageKinds.length &&
        this.packageStatus &&
        this.packageKinds.find(v => v.offer_id === this.packageType)
      )
    }
  },
  created () {
    this.getUserInfo().then(() => {
      this.visibleTips()
      this.getPriceList()
      // this.getMemberRights()
      this.getRebateInfo()
      // this.getFlingBanners()
    })
  },
  methods: {
    ...mapActions('store', ['getUserInfo', 'getRebateInfo']),

    /**
     * 跳转特卖活动
     */
    jumpFling (configer) {
      this.$router.push({ name: configer.url, query: { cid: configer.column } })
    },
    /**
     * 会员办理选项切换
     */
    switchMeal (index, type) {
      this.current = index
      this.selectedType = type
      this.packageType = ''
      this.packageStatus = false
    },

    /**
     * 套餐tab 切换
     */
    switchPackage (index, id) {
      this.current = index
      this.packageType = id
      this.selectedType = ''
      this.packageStatus = true
    },

    showPackageInfo () {
      this.packageInfo.show = true
    },

    closePackageInfo () {
      this.packageInfo.show = false
    },

    closeTips () {
      this.showTips = false
    },

    visibleTips () {
      if (this.userInfo.level > 1) {
        this.showTips = true
      }
    },

    tipCheckHandler () {
      this.tipChecked = !this.tipChecked
    },

    cancelHandler () {
      this.dialog.show = false
    },

    /**
     * 升级套餐
     */
    upgradePackage () {
      this.upgradePackageInfo.show = true
    },

    /**
     * 升级套餐二次确认关闭
     */
    ungradeCancelHandler () {
      this.upgradePackageInfo.show = false
    },

    /**
     * 升级套餐二次确认 办理
     */
    async ungradeConfrimHandler () {
      if (flag) {
        return false
      }
      flag = true
      await this.upgradePackageHandler(this.packageType)
      this.upgradePackageInfo.show = false
      this.$router.push({ name: 'personalCenter' })
      flag = false
    },

    /**
     * 办理接口
     */
    async upgradePackageHandler (id) {
      this.$toast.loading('正在办理,请稍后...')
      const res = await this.$axios.post('api/member/pkg-order', {
        offer_id: id
      })
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('办理申请已提交')
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 办理会员
     */
    submit () {
      if (!this.packageStatus) {
        this.dialog.show = true
        this.mealName = this.priceList[this.current].name
        this.priceList.forEach(v => {
          // console.log(v)
          if (v.type === this.selectedType) {
            this.mealDetails = { ...v }
          }
        })
      }
    },

    async confrimHandler () {
      if (flag) {
        return false
      }
      flag = true
      if (!this.packageStatus) {
        await this.submitHandler()
      }
      flag = false
    },

    /**
     * 开通
     */
    async submitHandler () {
      this.$toast.loading({
        duration: 30000,
        forbidClick: true,
        message: '正在办理,请稍后...'
      })
      // console.log(this.level)
      const res = await this.$axios.post('api/member/order', {
        level: this.level,
        type: this.selectedType
      })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 0) {
          this.dialog.show = false
          this.$toast('已成功提交办理申请')
          this.getUserInfo()
          setTimeout(() => {
            this.$router.back()
          }, 2000)
          // location.href = data.redirect
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 获取价格列表
     */
    async getPriceList () {
      const res = await this.$axios.get('api/member/price')
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.memmberName = data.member[0].name
          this.level = data.member[0].level
          this.priceList = data.member[0].price
          this.packageKinds = data.package
          if (this.packageKinds.length) {
            this.packageStatus = true
            this.packageType = this.packageKinds[0].offer_id
          } else {
            this.selectedType = this.priceList[0].type
          }
        } else {
          this.$toast(msg)
        }
      }
    },

    async getMemberRights () {
      const data = await api.getLocationCodingHandler('viphome-1')
      if (data) {
        this.memberRights = data
      }
    },

    /**
     * 获取特卖列表
     */
    async getFlingBanners () {
      const data = await api.getLocationCodingHandler('viphome-2')
      if (data) {
        this.flingBanners = data
      }
    }
  }
}
</script>

<style lang="less" scoped>
.member-center {
  .header {
    width: 100%;
    height: 2.65rem;
    background: url("../assets/img/member-center/member-center-bg.png") top
      no-repeat #fff;
    background-size: 100%;
    .user-info {
      padding-top: 0.7rem;
      .flex-column-center;
      img {
        width: 0.82rem;
        height: 0.82rem;
      }
      .phone {
        padding: 0.1rem 0.15rem;
        color: #d5bb9e;
        font-size: @fz26;
        font-weight: 700;
      }
      .level {
        color: #b19475;
        font-size: @fz24;
      }
    }
  }
  .upgrade-package {
    padding-bottom: 0 !important;
    .package-price-options {
      font-size: @fz24;
      .flex-column;
      align-items: center;
      .package-option {
        &:first-child {
          margin-top: 0;
        }
        width: 6rem;
        padding: 0 0.15rem;
        height: 1.83rem;
        margin-top: 0.25rem;
        border: 0.02rem solid #ebebeb;
        border-radius: 0.18rem;
        color: @base;
        .package-tit {
          .flex-between;
          height: 0.7rem;
          border-bottom: 0.5px dashed #ebebeb;
          .tit {
            img {
              width: 0.32rem;
              height: 0.27rem;
              padding: 0 0.1rem;
            }
          }
          .name {
            font-weight: bold;
            padding-right: 0.4rem;
          }
        }
        .package-desc {
          padding-top: 0.1rem;
          font-size: @fz22;
          line-height: 2;
        }
        .view-more-desc {
          color: #3498db;
          font-size: @fz22;
          color: #3498db;
        }
      }
      .package-option-checked {
        position: relative;
        border-color: #fd903c;
        background-color: #fffaf4;
        &::after {
          content: "";
          position: absolute;
          width: 0.44rem;
          height: 0.45rem;
          background: url("../assets/img/member-center-checked.png") center
            no-repeat;
          background-size: 100%;
          top: 0;
          right: 0;
        }
        .package-tit {
          border-color: #fd903c;
        }
      }
    }
  }
  .open-member {
    padding: 0.25rem 0 0.36rem;
    background-color: #fff;
    .title {
      width: 100%;
      font-size: @fz32;
      text-align: center;
      color: #fd913d;
      margin-bottom: 0.42rem;
      position: relative;
      .title-wrapper {
        position: relative;
        &::before,
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 0.25rem;
          height: 0.25rem;
        }
        &::before {
          left: -0.5rem;
          background: url("../assets/img/open-l.png") center no-repeat;
          background-size: 100%;
        }
        &::after {
          right: -0.5rem;
          background: url("../assets/img/open-r.png") center no-repeat;
          background-size: 100%;
        }
      }
      em {
        color: @base;
        font-weight: 700;
      }
    }
    .price-options {
      padding: 0 0.6rem;
      .flex-between;
      .option {
        width: 2.91rem;
        height: 1.41rem;
        border: 0.02rem solid #ebebeb;
        border-radius: 0.12rem;
        box-sizing: border-box;
        font-size: @fz24;
        color: @base;
        .flex-column-center;
        justify-content: center;
        span:nth-child(2) {
          padding-top: 0.1rem;
        }
        em {
          font-size: @fz32;
          font-weight: 700;
        }
      }
      .option-checked {
        position: relative;
        border-color: #fd903c;
        background-color: #fffaf4;
        &::after {
          content: "";
          position: absolute;
          width: 0.44rem;
          height: 0.45rem;
          background: url("../assets/img/member-center-checked.png") center
            no-repeat;
          background-size: 100%;
          top: 0;
          right: 0;
        }
      }
    }
    .open-member-functional {
      margin: 0.4rem auto 0.3rem;
      width: 6.3rem;
      height: 0.8rem;
      text-align: center;
      button {
        width: 100%;
        height: 100%;
        font-weight: 660;
        letter-spacing: 0.05rem;
        background: linear-gradient(
          90deg,
          rgba(255, 130, 52, 1) 0%,
          rgba(250, 176, 80, 1) 100%
        );
        border-radius: 30px;
        font-size: @fz26;
        color: #fff;
      }
    }
    .records {
      font-size: @fz28;
      text-align: center;
      margin-top: 0.25rem;
      color: #4a90e2;
    }
    .tips {
      .flex-center;
      font-size: @fz24;
      color: @c80;
      display: none;
      .tip-check {
        width: 0.3rem;
        height: 0.3rem;
        border: 0.5px solid #f18a0f;
        margin-right: 0.15rem;
      }
      .tip-checked {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          width: 0.24rem;
          height: 0.24rem;
          background-color: #f18a0f;
          top: 50%;
          left: 50%;
          transform: translate(-50%; -50%);
        }
      }

      .rule {
        color: #3498db;
      }
    }
  }
  .member-privilege {
    margin-top: 0.2rem;
    background-color: #fff;
    .title {
      text-align: center;
      padding-top: 0.23rem;
      height: 0.31rem;
      img {
        width: 3.93rem;
        height: 0.31rem;
      }
    }
    .privilege-list {
      margin-top: 0.3rem;
      padding: 0 0.3rem;
      .flex-between;
      flex-wrap: wrap;
      .privilege-item {
        width: 2.9rem;
        height: 1.42rem;
        padding: 0 0.2rem;
        background-color: #fffbf6;
        border-radius: 0.12rem;
        margin-bottom: 0.3rem;
        .flex-between;
        .intro {
          width: 1.4rem;
          .flex-column;
          .name {
            color: #a47055;
            font-weight: 700;
            font-size: @fz28;
            font-family: PingFang SC Medium;
            .ellipsis;
          }
          .desc {
            font-size: @fz22;
            color: #cc9b75;
            .ellipsis2;
          }
        }
        .rights-icon {
          width: 1.04rem;
          height: 1.04rem;
          border-radius: 50%;
          overflow: hidden;
        }
      }
    }
  }
  .comming-soon {
    text-align: center;
    background-color: #fff;
    padding-bottom: 0.23rem;
    button {
      width: 3.2rem;
      height: 0.8rem;
      border: 0.5px solid #fea660;
      border-radius: 30px;
      font-size: @fz28;
      color: #f8aa6c;
    }
  }
  .member-fling-module {
    margin-top: 0.26rem;
    padding-top: 0.35rem;
    background-color: #fff;
    .fling-tit {
      text-align: center;
      height: 0.31rem;
      img {
        width: 3.93rem;
        object-fit: contain;
      }
    }
    .fling-banners {
      padding: 0.35rem 0.2rem;
      .banner {
        margin-top: 0.2rem;
        .jump-fling {
          width: 100%;
          height: 2.4rem;
          img {
            object-fit: contain;
          }
        }
      }
    }
  }
  .dialogs {
    .open-member-desc {
      line-height: 1.5;
      padding: 0.8rem 0.5rem;
      text-align: left;
    }
    .package-desc {
      line-height: 1.5;
      font-size: @fz24;
      padding: 0.5rem 0.25rem;
    }
  }
}
</style>
